import React from 'react';

const Participants = (props) => {
  let items = props.items.map((participant, i) => {
    let name = participant.displayName || participant.name || participant.id;
    
    return (
      <li key={i} title={participant.name}>
        <span>{name}</span>
      </li>
    );
  });

  return (
    <ul className={props.className}>
      {items}
    </ul>
  );
};

export default function CellParticipantList(props) {
  let element = null;

  if(props.participants) {
    element = (
      <div className="abl-meeting-participants">
        <Participants
          className="abl-participants-list abl-meeting-teacher" 
          items={props.participants.teacher} />
        <Participants 
          className="abl-participants-list abl-meeting-cohort"
          items={props.participants.cohort} />
      </div>
    );
  }

  return element;
};


/** WEBPACK FOOTER **
 ** ./src/js/components/schedule/cell_participant_list.js
 **/